import { render, staticRenderFns } from "./FieldChoiceDetail.vue?vue&type=template&id=6f898f26&scoped=true"
import script from "./FieldChoiceDetail.vue?vue&type=script&lang=js"
export * from "./FieldChoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./FieldChoiceDetail.vue?vue&type=style&index=0&id=6f898f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f898f26",
  null
  
)

export default component.exports